import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import ItemOrder from "../components/ItemOrder";
import {clickedNodeAction} from '../../../actions/clickedNodeActions';
import {addContextProperty, removeContextProperty} from "../../../actions/contextPropertiesActions";
import PanelLayout from "../components/PanelLayout";
import ToggleableContent from "../components/ToggleableContent";
import axios from "axios";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import ToggleableValueTypeSelector from "../components/ToggleableValueTypeSelector";

class SorterOnlyPanel extends Component {
    constructor(props) {
        super(props);
        this.description = "Scoped property declared by Sorter Block";
        this.dynamicTypes = [
            {
                text: "Constant Value",
                xmlType: "constantValue"
            },
            {
                text: "Context Property",
                xmlType: "contextProperty"
            },
        ];
        this.itemTypes = [
            {
                text: "Context Property",
                xmlType: "contextProperty"
            },
            {
                text: "Item Property",
                xmlType: "itemProperty"
            },
        ];

        this.types = [
            {
                text: "Constant Value",
                xmlType: "constantValue"
            },
            {
                text: "Context Property",
                xmlType: "contextProperty"
            }
        ];

        this.hasOptions = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.sorterOptions;

        this.defaultInputValue = "";
        this.defaultSkipValue = 100;
        this.state = {
            sorterOptions: this.hasOptions ? this.props.clickedNodeInfo.extras.options.sorterOptions : {
                sorterProperties: [{
                    propertyId: 1,
                    comparator: "DoubleComparator",
                    property: "dynamicProperty",
                    propertyType: "contextProperty",
                    propertyValue: "",
                    orderAscending: "desc",
                }],
                mespExpression: "",
                order: "keep",
                orderAscending: "desc",
                storeAllItemCountPropertyName: "",
                isMaxResultsSelected: false,
                maxResults: 500,
                offsetPropertyType: "constantValue",
                offsetPropertyValue: this.defaultSkipValue,
                isSkipCountSelected: false
            },
            itemProperties: [],
        };
        this.handlePropertiesRemove = this.handlePropertiesRemove.bind(this)
        this.handlePropertiesChange = this.handlePropertiesChange.bind(this)
        this.handlePropertiesAdd = this.handlePropertiesAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateSorterOptions = this.updateSorterOptions.bind(this);
        this.deleteContextProps = this.deleteContextProps.bind(this);
        this.addContextProp = this.addContextProp.bind(this);
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.sorterOptions) {
            this.setState({sorterOptions: this.props.clickedNodeInfo.extras.options.sorterOptions}, () => {
                this.updateSorterOptions();
            });
        } else {
            this.updateSorterOptions();
        }
        this.getItemUserProperties();
    }

    async getItemUserProperties() {
        await axios.get(this.props.properties.databaseUrl + "/properties/items", axiosConfig())
            .then(response => {
                this.setState(() => ({
                    itemProperties: response.data
                }));
            })
            .catch(err => {
                if (err.response)
                    this.props.showToastForBackend(err.response.data);
                else
                    this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
            });
    }


    handlePropertiesChange(indexToChange, propertyName, newValue) {
        if (this.state.sorterOptions.sorterProperties) {
            this.setState(prevState => ({
                ...prevState,
                sorterOptions: {
                    ...prevState.sorterOptions,
                    sorterProperties: [
                        ...prevState.sorterOptions.sorterProperties.map(
                            (value, index) => {
                                if (index !== indexToChange) {
                                    return value;
                                } else {
                                    return {...value, [propertyName]: newValue}
                                }
                            })
                    ]
                }
            }), () => {
                this.updateSorterOptions();
            })
        } else {
            this.setState(prevState => ({
                ...prevState,
                sorterOptions: {
                    ...prevState.sorterOptions,
                    sorterProperties: [
                        {...prevState.sorterOptions, [propertyName]: newValue}]
                }
            }), () => {
                this.updateSorterOptions();
            })
        }
    }


    handlePropertiesAdd(newProperty) {
        if (this.state.sorterOptions.sorterProperties) {
            this.setState(prevState => ({
                ...prevState,
                sorterOptions: {
                    ...prevState.sorterOptions,
                    sorterProperties: [
                        ...prevState.sorterOptions.sorterProperties,
                        newProperty
                    ]
                }
            }), () => {
                this.updateSorterOptions();
            })
        } else {
            this.setState(prevState => ({
                ...prevState,
                sorterOptions: {
                    ...prevState.sorterOptions,
                    sorterProperties: [
                        ...prevState.sorterOptions,
                        newProperty
                    ]
                }
            }), () => {
                this.updateSorterOptions();
            })
        }
    }


    handlePropertiesRemove(indexToRemove) {
        this.setState(prevState => ({
            ...prevState,
            sorterOptions: {
                ...prevState.sorterOptions,
                sorterProperties: [
                    ...prevState.sorterOptions.sorterProperties.filter((value, index) =>
                        index !== indexToRemove
                    )
                ]
            }
        }), () => {
            this.updateSorterOptions();
        })
    }


    handleChange(property, value) {
        this.setState(prevState => ({
            sorterOptions: {
                ...prevState.sorterOptions,
                [property]: value
            }
        }), () => {
            if (property === "storeAllItemCountPropertyName") {
                this.addContextProp();
            }

            this.updateSorterOptions();
        });
    }

    updateSorterOptions() {
        const sorterOptions = this.state.sorterOptions;
        const clickedNodeInfo = this.props.clickedNodeInfo;

        let sorterOnlyPanelInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(sorterOnlyPanelInfo.extras, "options")) {
            sorterOnlyPanelInfo.extras.options = {};
        }
        sorterOnlyPanelInfo.extras.options.sorterOptions = sorterOptions;
        this.props.clickedNodeAction(sorterOnlyPanelInfo);
    }

    addContextProp() {
        const newContextProp = {
            name: this.state.sorterOptions["storeAllItemCountPropertyName"],
            publicName: this.state.sorterOptions["storeAllItemCountPropertyName"],
            description: this.description,
            addedByUpdater: true
        };
        if (this.isContextPropertyExists()) {
            this.deleteContextProps();
        }
        if (this.validateFields()) {
            this.props.addContextProperty(newContextProp);
        }
    }

    deleteContextProps() {
        const toBeDeletedContextProp = this.props.contextProps.find(contextProp => contextProp.description === this.description);
        this.props.removeContextProperty(toBeDeletedContextProp);
    }

    validateFields() {
        if (this.state.sorterOptions["storeAllItemCountPropertyName"].length < 1)
            return false;
        return true;
    }

    isContextPropertyExists() {
        if (this.props.contextProps.some((prop) => prop.name === this.state.sorterOptions["storeAllItemCountPropertyName"]))
            return true;
        if (this.props.contextProps.some((prop) => prop.description === this.description))
            return true;
        return false;
    }

    render() {
        return (
            <PanelLayout>
                <ItemOrder
                    handleChange={this.handleChange}
                    handlePropertiesAdd={this.handlePropertiesAdd}
                    handlePropertiesChange={this.handlePropertiesChange}
                    handlePropertiesRemove={this.handlePropertiesRemove}
                    sorterOptions={this.state.sorterOptions}
                    itemTypes={this.itemTypes}
                    dynamicTypes={this.dynamicTypes}
                    selectedProperty="property"
                    selectedOption="propertyType"
                    selectedValue="propertyValue"
                    defaultInputValue={this.defaultInputValue}
                    itemProperties={this.state.itemProperties}
                />

                <ToggleableContent label="Maximum Item Count"
                                   isSelected={this.state.sorterOptions.isMaxResultsSelected}
                                   onToggle={() => this.handleChange("isMaxResultsSelected", !this.state.sorterOptions.isMaxResultsSelected)}
                >
                    <div className="filter-rule">
                        <div className="input-container">
                            <input name="numberInput"
                                   onChange={(event) => this.handleChange("maxResults", event.target.value)}
                                   className="number-input" type="number"
                                   value={this.state.sorterOptions.maxResults}/>
                        </div>
                    </div>
                </ToggleableContent>
                <ToggleableValueTypeSelector
                    label="Skip Count"
                    nonSelectedLabel="Don't skip"
                    selectedType={this.state.sorterOptions["offsetPropertyType"]}
                    selectedOption="offsetPropertyType"
                    value={this.state.sorterOptions["offsetPropertyValue"]}
                    selectedValue="offsetPropertyValue"
                    handleChange={this.handleChange}
                    types={this.types}
                    isSelectorSelected={this.state.sorterOptions.isSkipCountSelected}
                    selectorProperty="isSkipCountSelected"
                    defaultInputValue={this.defaultSkipValue}
                />
            </PanelLayout>
        )
    }
}

function mapStateToProps(state) {
    return {
        clickedNodeInfo: state.clickedNodeInfo,
        node: state.modalInfo.node,
        properties: state.properties,
        contextProps: state.contextProperties
    }
}

export default connect(mapStateToProps, {
    hideModal,
    clickedNodeAction,
    addContextProperty,
    showToastForBackend,
    showToastForFrontend,
    removeContextProperty
})(SorterOnlyPanel);
